// @core/api/endpoints/workflow/cancel_pipeline_run_as_request.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CancelPipelineRunAsRequestRequest,
  PipelineRunAsRequestResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Cancel a pending execution identity request
 * Performs cancel operation on pipeline run as request.
 */
export async function CancelPipelineRunAsRequest(
  request_id: string,
  data: CancelPipelineRunAsRequestRequest,
  options?: RequestOptions
): Promise<PipelineRunAsRequestResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/run-as-requests/:request_id/cancel`;
  requestPath = requestPath.replace(':request_id', encodeURIComponent(request_id));
  const requestOptions = options;
  return client.post<PipelineRunAsRequestResponse>(requestPath, data, requestOptions);
}
